import React, { useContext, useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import storage from "../Assets/js/Global";
import { Fingerprint } from "lucide-react";
import { CheckCircle } from "lucide-react";
import { GlobalContext } from "../Context/GlobalContext";

const BiometricDrawer = ({ openDirectly = false, onClose }) => {
  const { translatedLabels } = useContext(GlobalContext);
  const screenLabels = translatedLabels?.common;
  const [show, setShow] = useState(false);
  const [step, setStep] = useState("intro");

  // useEffect(() => {
  //   if (openDirectly) {
  //     setStep("success");
  //     setShow(true);
  //   } else {
  //     const biometricPreference = storage.get("biometricAuthEnabled");
  //     if (biometricPreference === false || biometricPreference === null) {
  //       setStep("intro");
  //       setShow(true);
  //     }
  //   }
  // }, [openDirectly]);

  useEffect(() => {
    if (openDirectly) {
      setStep("success");
      setShow(true);
    } else {
      const biometricPreference = storage.get("biometricAuthEnabled");
      if (biometricPreference === null) {
        setStep("intro");
        setShow(true);
      }
    }
  }, [openDirectly]);

  const handleEnableBiometric = () => {
    setStep("success");
  };

  const handleContinue = () => {
    storage.set("biometricAuthEnabled", true);
    const loginObj = storage.get("loginObj");
    let userId = loginObj?.userKey;
    window.ReactNativeWebView?.postMessage(`enableBioMetrics|${userId}`);
    setShow(false);
    onClose?.(true);
  };

  const handleSkip = () => {
    storage.set("biometricAuthEnabled", false);
    const loginObj = storage.get("loginObj");
    let userId = loginObj?.userKey;
    window.ReactNativeWebView?.postMessage(`skipBioMetrics|${userId}`);
    setShow(false);
    onClose?.(false);
  };

  const handleClose = () => {
    setShow(false);
    const isBiometricEnabled = storage.get("biometricAuthEnabled") === true;
    onClose?.(isBiometricEnabled);
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="bottom"
      backdrop={true}
      keyboard={openDirectly}
      animation={true.toString()}
      className="p-0 text-black shadow-lg biometric-drawer"
      style={{
        height: "60vh",
        backgroundColor: "#fff",
        borderTopLeftRadius: "16px",
        borderTopRightRadius: "16px",
      }}
    >
      <Offcanvas.Body className="px-4 pt-4">
        <div
          style={{
            height: "54.5vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {step === "intro" ? (
            <>
              <div className="mb-5">
                <Fingerprint
                  size={60}
                  color={step === "success" ? "#2196f3" : "#607D8B"}
                  strokeWidth={1.8}
                />
              </div>
              <h4 className="text-center">
                {screenLabels?.bio_text_1?.label_value ||
                  "Biometric authentication is now available"}
              </h4>
              <p className="text-muted text-center small my-3">
                {screenLabels?.bio_text_2?.label_value ||
                  "Log in to your account using your phone’s biometric credentials."}
              </p>
              <button
                className="btn btn-primary w-100 mb-3"
                onClick={handleEnableBiometric}
              >
                {screenLabels?.enable_bio_login?.label_value ||
                  "Enable biometric login"}
              </button>
              <button
                className="btn btn-outline-primary w-100"
                onClick={handleSkip}
              >
                {screenLabels?.skip_for_now?.label_value || "Skip for now"}
              </button>
            </>
          ) : (
            <>
              <CheckCircle
                size={60}
                color="#4CAF50"
                strokeWidth={1.8}
                style={{ animation: "pop 0.3s ease-in-out" }}
                className="mb-5"
              />
              <h4 className="text-center mb-3">
                {screenLabels?.all_set_secure?.label_value ||
                  "All set for quick & secure logins!"}
              </h4>
              <p className="text-muted small text-center">
                {screenLabels?.no_pass_needed?.label_value ||
                  "Next time you log in, just use your fingerprint or face — no password needed."}
              </p>
              <button
                className="btn btn-primary w-100 my-3"
                onClick={handleContinue}
              >
                {screenLabels?.got_it?.label_value || "Got it"}
              </button>
            </>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default BiometricDrawer;
